import { ICON__pencil_solid } from '@/assets/icons_fa';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_user } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_user_settings_update_avatar } from '@/state/user/settings/remote_user_settings_update_avatar';
import { path_relative_to_absolute } from '@/utils/utils_files_client';
import { upload_image_single } from '@/utils/utils_upload';
import { DTO__file_data } from '@shared/dto/+image/image_asset_base/DTO__file_data';
import { get_avatar_fallback_from_name } from '@shared/utils/utils_string';
import { useTranslation } from 'react-i18next';

export default function S_VIEW__account_info() {
  const dispatch = use_dispatch();

  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { toast } = useToast();

  const { user_full_name, user_url_relative_avatar } = use_slice_user(['user_full_name', 'user_url_relative_avatar']);

  /*
   * EVENTS
   */

  function onClick() {
    upload_image_single(toast, onImageLoaded, t);
  }

  async function onImageLoaded(file_data: DTO__file_data) {
    await dispatch(remote_user_settings_update_avatar(file_data));
  }

  /*
   * HTML
   */

  return (
    <div className="flex items-center gap-2 ">
      <Avatar className="!w-[10rem] !h-[10rem] !cursor-pointer" {...{ onClick }}>
        <div className="absolute size-full flex justify-center items-center backdrop-blur-sm backdrop-brightness-50 opacity-0 hover:opacity-100 duration-300">
          <ICON__pencil_solid className="!w-7 !h-7 !cursor-pointer" />
        </div>
        <AvatarImage src={path_relative_to_absolute(user_url_relative_avatar)} />
        <AvatarFallback className="!text-[50px]">{get_avatar_fallback_from_name(user_full_name)}</AvatarFallback>
      </Avatar>
    </div>
  );
}
